import { Component, cloneElement } from "react"
import PropTypes from "prop-types"
import { isEqual, size, cloneDeep } from "lodash"
import "./style.scss"

class CompareSegments extends Component {
  static propTypes = {
    addComparisonItem: PropTypes.func.isRequired,
    removeComparisonItem: PropTypes.func.isRequired,
    setSegmentNormalization: PropTypes.func.isRequired,
    splitItem: PropTypes.func.isRequired,
    comparisonItems: PropTypes.array.isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    setComparisonItems: PropTypes.func.isRequired,
    setParentComparisonItems: PropTypes.func.isRequired,
    newItems: PropTypes.array,
  }

  componentDidMount() {
    const { setComparisonItems, comparisonItems } = this.props
    setComparisonItems(cloneDeep(comparisonItems))
  }

  componentDidUpdate(prevProps) {
    const { newItems, setParentComparisonItems, comparisonItems } = this.props
    if (!isEqual(prevProps.newItems, newItems) || size(comparisonItems) !== size(newItems)) {
      setParentComparisonItems(cloneDeep(newItems))
    }
  }

  render() {
    const { children } = this.props

    return <div className="modules_compare-segments-root">
      {cloneElement(children, { ...this.props })}
    </div>
  }
}

export default CompareSegments
